<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="产品中心" />
	<div class="product-center">
		<el-row class="flex-container">
		  <!-- 左侧导航栏 -->
		  <el-col :span="6" class="sidebar">
			<h3 class="sidebar-title">产品分类</h3> <!-- 添加的标题 -->
			<el-menu
			  :default-active="selectedCategory"
			  @select="handleSelect"
			  class="el-menu-vertical-demo"
			>
			  <el-menu-item v-for="category in categories" :key="category.id" :index="category.id.toString()">
				{{ category.name }}
			  </el-menu-item>
			</el-menu>
		  </el-col>

		  <!-- 右侧产品展示 -->
		  <el-col :span="18" class="right-product">
			<el-row :gutter="20" style="margin-left: 20px; margin-right: 20px;">
			  <el-col :span="6" v-for="product in filteredProducts" style="margin-bottom: 20px;">
				<el-card :body-style="{ padding: '20px' }" class="image-item">
				  <el-image :src="product.image" alt=""  style="width: 250px; height: 250px" class="product-image" fit="scale-down"
				  :preview-src-list="srcList"/>
				  <div style="padding: 14px;">
					<h3 style="text-align: center;">{{ product.name }}</h3>
<!-- 					<p>{{ product.description }}</p> -->
				  </div>
				</el-card>
			  </el-col>
			</el-row>
		  </el-col>
		</el-row>
	  </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
import { categories, products } from "./data/product.js"
export default {
  components: {
    Banner
  },
  data() {
      return {
        // 导航栏的产品类型
        categories: [],
        // 所有产品的数据
        products: [],
        selectedCategory: 1, // 默认选中的类别
		srcList: [],
      };
    },
	
  mounted() {
	  this.categories = categories
	  this.products = products
	  this.handleSelect(this.$route.query.item)
  },
  
  watch:{
	  $route(to, from){
		  console.log(to, from)
		   this.handleSelect(to.query.item)
	  }
  },
  
  computed: {
	  filteredProducts() {
		return this.products.filter(
		  (product) => product.category === this.selectedCategory
		);
	  },
	},
	
  methods: {
	  handleSelect(categoryId) {
		this.selectedCategory = parseInt(categoryId);
		this.srcList = this.products.filter(
		  (product) => product.category === this.selectedCategory
		).map((product) => product.image)
	  },
  }
};
</script>

 <style lang="scss" scoped>
	 
.product-center{
	margin-left: 100px;
	margin-right: 100px;
	.flex-container{
		display: flex; /* 使用 Flexbox 布局 */
	}
	
	.sidebar {
	  display: flex;
	  flex-direction: column; /* 纵向排列内容 */
	}
	
	.image-item {
		height: 400px;
		display: flex;
		flex-direction: column;
		/* 纵向排列 */
		justify-content: center;
		/* 垂直居中 */
		align-items: center;
		/* 水平居中 */
		text-align: center;
		/* 文字居中 */
	}

	.sidebar-title{
		background-color: #fff;
		text-align: center;
		font-size: 30px;
		padding-top: 20px;
		border-bottom: 2px solid #dcdfe6; /* 给标题加下划线 */
		padding-bottom: 5px; /* 调整与下划线的距离 */
	}
	.right-product{
		background-color: #fff;
		display: flex;
		flex-direction: column; /* 纵向排列内容 */
	}
	.el-menu-item {
	  border-bottom: 1px solid #dcdfe6; /* 给每个导航项加下划线 */
	}
	.el-menu-item:hover {
	  background-color: #f5f7fa; /* 导航项悬停时的背景色 */
	}
}
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>